import jwtAuthAxios from "../../services/jwtAuth";
import {
  createSlice,
  createAsyncThunk,
  createEntityAdapter,
} from "@reduxjs/toolkit";

export const getGedung = createAsyncThunk("gedung/getAll", async () => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.get("v1/gedung");
  return response.data;
});
export const getGedungById = createAsyncThunk("gedung/getById", async (id) => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.get(`v1/gedung/${id}`);
  return response.data;
});

export const deleteGedung = createAsyncThunk("gedung/delete", async (id) => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  await jwtAuthAxios.delete(`v1/gedung/${id}`);
  return id;
});

export const saveGedung = createAsyncThunk("gedung/save", async (payload) => {
  let token = await localStorage.getItem("auth_token");
  jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
  const response = await jwtAuthAxios.post("v1/gedung", payload);
  return response.data;
});
export const updateGedung = createAsyncThunk(
  "gedung/update",
  async (request) => {
    let token = await localStorage.getItem("auth_token");
    jwtAuthAxios.defaults.headers.common["Authorization"] = "Bearer " + token;
    const response = await jwtAuthAxios.put("v1/gedung", request);
    return response.data;
  }
);

const initialState = {
  loading: false,
  dataGedung: [],
};

const gedungSlice = createSlice({
  name: "gedung",
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getGedung.pending, (state) => {
        state.loading = true;
      })
      .addCase(getGedung.fulfilled, (state, action) => {
        state.dataGedung = action.payload;
        state.loading = false;
      })
      .addCase(getGedung.rejected, (state, action) => {
        state.loading = false;
        console.error("Error during getMatkul:", action.error);
      });
    builder
      .addCase(deleteGedung.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteGedung.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteGedung.rejected, (state, action) => {
        state.loading = false;
        console.error("Error during deleteGedung:", action.error);
      })
      .addCase(saveGedung.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveGedung.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(saveGedung.rejected, (state, action) => {
        state.loading = false;
        console.error("Error during saveGedung:", action.error);
      })
      .addCase(updateGedung.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateGedung.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateGedung.rejected, (state, action) => {
        state.loading = false;
        console.error("Error during updateGedung:", action.error);
      });
  },
});

export const gedungSelectors = (state) => state.gedung;
export default gedungSlice.reducer;
